export default __webpack_public_path__ + "static/media/service-thumb-concrete-walkway.a9372995.jpg";